// src/components/ParticipantUpload.js
import React, { useState } from 'react';
import api from '../services/api';
import { Box, Button, Typography, CircularProgress, Alert } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const ParticipantUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('info'); // 'info', 'success', or 'error'

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setMessage('');
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setMessage('Please select a file first.');
      setMessageType('error');
      return;
    }

    setUploading(true);
    setMessage('');
    
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const response = await api.post('/api/participants/upload-csv', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage(`Upload successful! Inserted: ${response.data.inserted}, Updated: ${response.data.updated}`);
      setMessageType('success');
    } catch (err) {
      setMessage(err.response?.data?.detail || 'File upload failed.');
      setMessageType('error');
    } finally {
      setUploading(false);
      setSelectedFile(null);
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button
          component="label"
          variant="outlined"
          startIcon={<CloudUploadIcon />}
        >
          Choose File
          <input type="file" accept=".csv" hidden onChange={handleFileChange} />
        </Button>
        <Typography sx={{ flexGrow: 1 }}>
          {selectedFile ? selectedFile.name : 'No file selected'}
        </Typography>
        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={!selectedFile || uploading}
        >
          {uploading ? <CircularProgress size={24} /> : 'Upload'}
        </Button>
      </Box>
      {message && (
        <Alert severity={messageType} sx={{ mt: 2 }}>
          {message}
        </Alert>
      )}
    </Box>
  );
};

export default ParticipantUpload;